var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { i18nConfig } from '../i18n';
import EvtEmitter from '../libs/event-emitter';
import { commonTool, netTool, stringTool, t, uaTool } from '../util';
import { getContentId, transformInitData } from './fairplay-utils';
import { builtHeadersFromXML, builtMessageXML, getChallenge } from './playready-utils';
var i18nCore = i18nConfig.core;
/**
 * 加密系统名称
 */
export var KeySystems;
(function (KeySystems) {
    KeySystems["FairPlayWebKit"] = "com.apple.fps.1_0";
    KeySystems["Widevine"] = "com.widevine.alpha";
    KeySystems["FairPlay"] = "com.apple.fps";
    KeySystems["Chacha"] = "com.tencent.chacha";
    KeySystems["PlayReady"] = "com.microsoft.playready";
    KeySystems["PlayReadyHardware"] = "com.microsoft.playready.hardware";
})(KeySystems || (KeySystems = {}));
export function getSupportedKeySystemConfig(keySystem) {
    switch (keySystem) {
        case KeySystems.FairPlayWebKit:
            return null;
        case KeySystems.Widevine:
            return {
                initDataTypes: ['cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
            };
        case KeySystems.FairPlay:
            return {
                initDataTypes: ['skd', 'cenc'],
                videoCapabilities: [
                    {
                        contentType: 'application/vnd.apple.mpegurl',
                        robustness: '',
                    },
                ],
            };
        case KeySystems.PlayReady:
        case KeySystems.PlayReadyHardware:
            return {
                initDataTypes: ['keyids', 'cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                    }],
            };
        default:
            return null;
    }
}
var ERR = 'error';
/**
 * DRM模块，支持Apple Fairplay Streaming和Widevine
 *
 * fairplay和widevine均可以通过EME标准接口实现，区别仅在fps需要服务端证书和两者的license请求包数据不同
 *
 * ! fairplay需要在macOS 10.14.4，ios 12.2以上才支持EME接口, webkit需要最低macOS 10.10.3, iOS 11.2
 */
var DRM = /** @class */ (function (_super) {
    __extends(DRM, _super);
    function DRM(media, config, logger) {
        var _this = _super.call(this) || this;
        /** 是否处于启用的状态 */
        _this.started = false;
        /**
         * 当前的keySession信息，包含mediaKey，session，initData等
         */
        _this.mediaKeyDescriptor = null;
        /**
         * mediaKey promise，给EME实现的版本使用
         */
        _this.mediaKeyPromise = null;
        /**
         * ====================================================================================
         * 标准EME实现的加密播放流程
         * 1. 创建mediaKey
         * 2. 通过mediaKey创建mediaKeySession，创建session请求信息，同时把mediaKey绑定到video上
         * 3. 监听mediaKeySession的message事件，请求license
         * 4. 更新session解密信息
         */
        /**
         * HTML5 video encrypted事件监听
         * @event encrypted
         */
        _this.onVideoEncrypted = function (event) {
            _this.logger.log('media encrypted', event);
            if (!_this.mediaKeyPromise) {
                _this.emit(ERR, {
                    code: 4 /* KEY_SYS_NOT_REQUESTED */,
                    message: t(i18nCore.ERROR_DRM_KEY_SYS_NOT_REQUESTED),
                });
                return;
            }
            _this.mediaKeyPromise
                .then(function (mediaKey) {
                if (!_this.mediaKeyDescriptor) {
                    _this.emit(ERR, {
                        code: 6 /* KEY_NOT_EXIST */,
                        message: t(i18nCore.ERROR_DRM_KEY_NOT_EXIST),
                    });
                    return;
                }
                // 这里主要是避免重复设置mediaKey，但是原则上这个事件应该只派发一次
                if (_this.mediaKeyDescriptor.hasInitialized) {
                    _this.logger.warn('Media key-session has been initialized but requested again');
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeys) {
                    _this.emit(ERR, {
                        code: 6 /* KEY_NOT_EXIST */,
                        message: t(i18nCore.ERROR_DRM_KEY_NOT_EXIST),
                    });
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeySession) {
                    _this.emit(ERR, {
                        code: 5 /* KEY_SESSION_NOT_EXIST */,
                        message: t(i18nConfig.ERROR_DRM_KEY_SESSION_NOT_EXIST),
                    });
                    return;
                }
                if (!event.initData) {
                    _this.emit(ERR, {
                        code: 7 /* INIT_DATA_EMPTY */,
                        message: t(i18nCore.ERROR_DRM_INIT_DATA_EMPTY),
                    });
                    return;
                }
                _this.mediaKeyDescriptor.mediaKeySession.generateRequest(event.initDataType, event.initData).catch(function (err) {
                    _this.emit(ERR, {
                        code: 13 /* KEY_SESSION_REQUEST_FAILED */,
                        message: t(i18nConfig.ERROR_DRM_KEY_SESSION_REQUEST_FAILED),
                    });
                    return;
                });
                _this.mediaKeyDescriptor.initData = event.initData;
                _this.mediaKeyDescriptor.hasInitialized = true;
            });
        };
        /**
         * HTML5 video webkitneededkey事件监听
         */
        _this.onVideoWebkitneedkey = function (event) {
            // 通过initData解析contentId，sdk://xxxx的格式
            var contentId = _this.config.fpsCustomContentId(event.initData);
            var cert = DRM.serverCertificate[KeySystems.FairPlayWebKit];
            if (!cert) {
                _this.emit(ERR, {
                    code: 9 /* FPS_CERTIFICATE_NOT_EXIST */,
                    message: t(i18nCore.ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST),
                });
                return;
            }
            // webkit这里需要重新拼接init信息，格式为assetId + certificate
            var initData = _this.config.fpsCustomTransformInitData(event.initData, contentId, cert);
            _this.mediaKeyDescriptor.initData = initData;
            // 避免重复创建session，防止请求的包数据错误
            if (_this.mediaKeyDescriptor.mediaKeySession) {
                _this.logger.warn('Media key-session has already been initialized');
                return;
            }
            _this.mediaKeyDescriptor.mediaKeySession = _this.createSessionWithMediaKey(_this.mediaKeyDescriptor.mediaKeys, initData);
            _this.mediaKeyDescriptor.assetID = contentId;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyadded = _this.onFPSKeySessionKeyAdded;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyerror = _this.onFPSKeySessionKeyError;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeymessage = function (event) {
                _this.onMediaKeySessionMessage(_this.mediaKeyDescriptor.mediaKeySession, event);
            };
        };
        _this.onFPSKeySessionKeyAdded = function (event) {
            // 目前没发现用途，主要是debug
        };
        _this.onFPSKeySessionKeyError = function (event) {
            var err = _this.mediaKeyDescriptor.mediaKeySession.error;
            if (err.systemCode) {
                var errCodeMap = {
                    // https://developer.apple.com/forums/thread/64204
                    1212433232: [10 /* HDCP_ERROR */, t(i18nCore.ERROR_DRM_HDCP)],
                };
                if (errCodeMap[err.systemCode]) {
                    _this.emit(ERR, {
                        code: errCodeMap[err.systemCode][0],
                        message: errCodeMap[err.systemCode][1],
                    });
                }
                return;
            }
            _this.emit(ERR, {
                code: 0 /* UNKNOWN */,
                message: t(i18nCore.ERROR_DRM_UNKNOWN),
            });
        };
        _this.media = media;
        _this.logger = logger;
        _this.config = __assign({ keySystem: null, fpsCustomContentId: getContentId, fpsCustomTransformInitData: transformInitData }, config);
        return _this;
    }
    Object.defineProperty(DRM.prototype, "isFairPlay", {
        /** 是否是fairplay */
        get: function () {
            var ks = this.config.keySystem;
            return ks === KeySystems.FairPlay || ks === KeySystems.FairPlayWebKit;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 检测环境是否支持指定的keySystem
     * @param keySystem EME key system name, e.g. com.apple.fps.1_0
     */
    DRM.isKeySystemSupported = function (keySystem) {
        var _a;
        var _b, _c;
        var condition = (_a = {},
            _a[KeySystems.FairPlayWebKit] = [
                (_b = self.WebKitMediaKeys) === null || _b === void 0 ? void 0 : _b.isTypeSupported(keySystem, 'video/mp4'),
            ],
            // 这里只检查EME接口是否存在
            _a[KeySystems.FairPlay] = [
                uaTool.browser.safari,
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.Widevine] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.PlayReady] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.PlayReadyHardware] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a);
        return (_c = condition[keySystem]) === null || _c === void 0 ? void 0 : _c.every(Boolean);
    };
    DRM.prototype.destroy = function () {
        this.removeAllListeners();
        this.logger = null;
    };
    /**
     * 更新配置参数，主要用于更新license地址和服务器证书等
     * @param config 配置参数
     */
    DRM.prototype.configure = function (config) {
        var _this = this;
        this.config = __assign(__assign({}, this.config), config);
        if (this.config.certificate) {
            Object.keys(this.config.certificate).forEach(function (key) {
                DRM.serverCertificate[key] = _this.config.certificate[key];
            });
        }
    };
    /**
     * DRM模块是否已启用
     */
    DRM.prototype.hasStarted = function () {
        return this.started;
    };
    /**
     * 初始化drm流程，需要外部主动调用
     * @param config 可选配置参数
     */
    DRM.prototype.init = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        if (config) {
                            this.configure(config);
                        }
                        if (!(typeof DRM.serverCertificate[this.config.keySystem] === 'string')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.requestServerCertificate(this.config.keySystem, DRM.serverCertificate[this.config.keySystem])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.bind();
                        this.logger.log('drm module initialized', this.config);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 重置。注销事件监听，销毁keySession等。
     * ! setMediaKeys 需要在src为空时调用，否则会抛出异常
     */
    DRM.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jobs, session, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.started = false;
                        if (!this.config.keySystem || !this.mediaKeyDescriptor)
                            return [2 /*return*/];
                        jobs = (_a = {},
                            _a[KeySystems.FairPlayWebKit] = this.cleanupFPSSession,
                            _a[KeySystems.FairPlay] = this.cleanupMediaKeySession,
                            _a[KeySystems.Widevine] = this.cleanupMediaKeySession,
                            _a[KeySystems.PlayReady] = this.cleanupMediaKeySession,
                            _a[KeySystems.PlayReadyHardware] = this.cleanupMediaKeySession,
                            _a);
                        this.videoEncryptedEventPicker(false);
                        if (!jobs[this.config.keySystem]) return [3 /*break*/, 4];
                        session = this.mediaKeyDescriptor.mediaKeySession;
                        this.mediaKeyPromise = null;
                        this.mediaKeyDescriptor = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, jobs[this.config.keySystem].call(this, session)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 绑定事件，创建mediaKey
     */
    DRM.prototype.bind = function () {
        // 如果进来的时候没有keySystem则不执行任何逻辑
        var userKeySystem = this.config.keySystem;
        if (!userKeySystem) {
            return;
        }
        ;
        if (!DRM.isKeySystemSupported(userKeySystem)) {
            this.logger.warn("\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301 ".concat(userKeySystem));
            return;
        }
        this.started = true;
        // 这个promise会在session创建后resolve
        this.mediaKeyPromise = this.createKeySystemAccess(userKeySystem);
        this.videoEncryptedEventPicker(true);
    };
    /**
     * 标准EME实现的清理方法。
     */
    DRM.prototype.cleanupMediaKeySession = function (mediaKeySession) {
        if (!this.media || !mediaKeySession)
            return Promise.resolve();
        mediaKeySession.onmessage = null;
        mediaKeySession.onkeystatuseschange = null;
        // 不处理close和setMediaKey过程中的报错
        mediaKeySession.close().catch(function () { });
        return this.media.setMediaKeys(null);
    };
    /**
     * 根据keySystem监听video的加密事件
     * @param toggle true为监听，false为取消监听
     */
    DRM.prototype.videoEncryptedEventPicker = function (toggle) {
        var _a;
        if (toggle === void 0) { toggle = true; }
        var supportedEvents = (_a = {},
            _a[KeySystems.FairPlayWebKit] = ['webkitneedkey', this.onVideoWebkitneedkey],
            _a[KeySystems.Widevine] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.FairPlay] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.PlayReady] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.PlayReadyHardware] = ['encrypted', this.onVideoEncrypted],
            _a);
        var _b = supportedEvents[this.config.keySystem], event = _b[0], handler = _b[1];
        if (toggle)
            this.media.addEventListener(event, handler);
        else
            this.media.removeEventListener(event, handler);
    };
    /**
     * 根据keySystem创建mediaKey session
     * @param mediaKey EME mediaKey
     * @param sessionInitData 加密事件抛出的initData，fps webkit使用
     */
    DRM.prototype.createSessionWithMediaKey = function (mediaKey, sessionInitData) {
        var _a;
        var creator = (_a = {},
            _a[KeySystems.FairPlayWebKit] = this.createFPSWebkitSession,
            _a[KeySystems.Widevine] = this.createMediaKeySession,
            _a[KeySystems.FairPlay] = this.createMediaKeySession,
            _a[KeySystems.PlayReady] = this.createMediaKeySession,
            _a[KeySystems.PlayReadyHardware] = this.createMediaKeySession,
            _a);
        return creator[this.config.keySystem].call(this, mediaKey, sessionInitData);
    };
    /**
     * 创建用于CDM访问的mediaKey
     * @param keySystem 加密类型
     */
    DRM.prototype.createKeySystemAccess = function (keySystem) {
        var _a;
        var creator = (_a = {},
            _a[KeySystems.Widevine] = this.requestKeySystemAccess,
            _a[KeySystems.FairPlay] = this.requestKeySystemAccess,
            _a[KeySystems.FairPlayWebKit] = this.requestFPSMediaKeys,
            _a[KeySystems.PlayReady] = this.requestKeySystemAccess,
            _a[KeySystems.PlayReadyHardware] = this.requestKeySystemAccess,
            _a);
        return creator[this.config.keySystem].call(this, keySystem);
    };
    /**
     * 根据keySystem请求license
     * @param data license请求的数据
     * @param callback license xhr请求的onload回调
     */
    DRM.prototype.requestLicense = function (data, callback) {
        var _a;
        if (!this.config.licenseUrl) {
            this.emit(ERR, {
                code: 12 /* LICENSE_NOT_EXIST */,
                message: t(i18nCore.ERROR_DRM_LICENSE_NOT_EXIST),
            });
            return;
        }
        var request = (_a = {},
            _a[KeySystems.FairPlayWebKit] = this.createFPSLicenseRequest,
            _a[KeySystems.Widevine] = this.createWidevineLicenseRequest,
            _a[KeySystems.PlayReady] = this.createPlayReadyLicenseRequest,
            _a[KeySystems.FairPlay] = this.createFPSLicenseRequest,
            _a[KeySystems.PlayReadyHardware] = this.createPlayReadyLicenseRequest,
            _a);
        return request[this.config.keySystem].call(this, data, callback);
    };
    /**
     * 请求服务端证书
     * @param keySystem 加密类型
     * @param url 证书地址
     */
    DRM.prototype.requestServerCertificate = function (keySystem, url) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, netTool.xhr({
                            method: 'GET',
                            responseType: 'arraybuffer',
                            url: url,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        DRM.serverCertificate[keySystem] = new Uint8Array(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第一步，创建CDM access
     */
    DRM.prototype.requestKeySystemAccess = function (keySystem) {
        return __awaiter(this, void 0, void 0, function () {
            var keySystemConfig, keySystemAccess, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keySystemConfig = getSupportedKeySystemConfig(keySystem);
                        if (!keySystemConfig) {
                            this.emit(ERR, {
                                code: 3 /* KEY_SYS_NOT_SUPPORTED */,
                                message: t(i18nCore.ERROR_DRM_KEY_SYS_NOT_SUPPORTED, keySystem),
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, self.navigator.requestMediaKeySystemAccess(keySystem, [keySystemConfig])];
                    case 2:
                        keySystemAccess = _a.sent();
                        return [2 /*return*/, this.onMediaKeySystemObtained(keySystem, keySystemAccess)];
                    case 3:
                        error_1 = _a.sent();
                        this.emit(ERR, {
                            code: 1 /* KEY_SYS_ACCESS_FAILED */,
                            message: t(i18nCore.ERROR_DRM_KEY_SYS_ACCESS_FAILED, keySystem),
                        });
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第二步，创建mediaKey
     */
    DRM.prototype.onMediaKeySystemObtained = function (keySystem, mediaKeySystemAccess) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaKeys, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mediaKeySystemAccess.createMediaKeys()];
                    case 1:
                        mediaKeys = _a.sent();
                        this.mediaKeyDescriptor = {
                            hasInitialized: false,
                            mediaKeySession: null,
                            mediaKeySystemAccess: mediaKeySystemAccess,
                            mediaKeys: mediaKeys,
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!(keySystem === KeySystems.FairPlay)) return [3 /*break*/, 4];
                        return [4 /*yield*/, mediaKeys.setServerCertificate(DRM.serverCertificate[KeySystems.FairPlay])];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.createSessionWithMediaKey(mediaKeys);
                        return [2 /*return*/, mediaKeys];
                    case 5:
                        e_2 = _a.sent();
                        this.emit(ERR, {
                            code: 2 /* KEY_SESSION_CREATION_FAILED */,
                            message: t(i18nCore.ERROR_DRM_KEY_SESSION_CREATION_FAILED),
                        });
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第三步，创建mediaKeySession，监听message事件
     */
    DRM.prototype.createMediaKeySession = function (mediaKeys) {
        var _this = this;
        // 这里避免重复创建导致session信息错误
        if (this.mediaKeyDescriptor.mediaKeySession) {
            this.logger.warn('Media key-session has already been initialized');
            return;
        }
        // https://www.w3.org/TR/encrypted-media/#dom-mediakeystatus
        // EME spec中定义的key status
        var keyStatusMap = {
            'output-restricted': [10 /* HDCP_ERROR */, t(i18nCore.ERROR_DRM_HDCP)],
            'output-downscaled': [10 /* HDCP_ERROR */, t(i18nCore.ERROR_DRM_HDCP)],
            'status-pending': null,
            'internal-error': [17 /* KEY_INTERNAL_ERROR */, t(i18nCore.ERROR_DRM_KEY_INTERNAL)],
            usable: null,
            expired: [15 /* KEY_EXPIRED */, t(i18nCore.ERROR_DRM_KEY_EXPIRED)],
            released: [16 /* KEY_RELEASED */, t(i18nCore.ERROR_DRM_KEY_RELEASED)],
        };
        this.mediaKeyDescriptor.mediaKeySession = mediaKeys.createSession();
        this.mediaKeyDescriptor.mediaKeySession.onkeystatuseschange = function (e) {
            var _a, _b, _c;
            (_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.keyStatuses) === null || _b === void 0 ? void 0 : _b.forEach) === null || _c === void 0 ? void 0 : _c.call(_b, function (status, keyId) {
                if (!_this.mediaKeyDescriptor)
                    return;
                if (keyStatusMap[status]) {
                    var _a = keyStatusMap[status], code = _a[0], message = _a[1];
                    _this.emit(ERR, {
                        code: code,
                        message: message,
                    });
                }
            });
        };
        this.mediaKeyDescriptor.mediaKeySession.onmessage = function (event) {
            _this.onMediaKeySessionMessage(_this.mediaKeyDescriptor.mediaKeySession, event);
        };
        this.media.setMediaKeys(mediaKeys)
            .then(function () {
            _this.logger.log('media keys set');
        })
            .catch(function (e) {
            _this.logger.error('media keys set failed', e);
            _this.emit(ERR, {
                code: 18 /* MEDIA_KEYS_SET_FAILED */,
                message: t(i18nCore.ERROR_DRM_MEDIA_KEYS_SET_FAILED),
            });
        });
    };
    /**
     * 第四步，请求license并更新session解密信息
     *
     * 这里webkit和EME的实现相同，两者共用一个方法处理
     */
    DRM.prototype.onMediaKeySessionMessage = function (keySession, event) {
        var _this = this;
        this.logger.log('received media key session message', event);
        // workaround: 20230523 M113版本的Chrome当使用4.10.2652.0版本的Widevine CDM时，会出现密钥失效的问题
        // 这里做一个兼容，从证书protobuf中读取到特征字段后直接抛出错误引导用户重启浏览器进程
        if (this.config.enableChromeM113Workaround
            && uaTool.browser.chrome
            && commonTool.compareVersion(uaTool.browser.version, '113') === 0) {
            try {
                if (new TextDecoder()
                    .decode(event.message)
                    .includes('4.10.2652.0')) {
                    this.emit(ERR, {
                        code: 14 /* KEY_SESSION_UPDATE_FAILED */,
                        message: '当前浏览器版本解密模块存在问题导致无法播放, 请尝试升级或重启浏览器进行修复[CDM=4.10.2652.0]',
                        fatal: true,
                    });
                    return;
                }
            }
            catch (e) { }
        }
        this.requestLicense(event, function (response) {
            var data = response.data;
            if (_this.config.licenseResponseSetup) {
                data = _this.config.licenseResponseSetup(data) || data;
            }
            if (!data) {
                // 如果无法解析或解析出不合法结果，报错并终止
                _this.emit(ERR, {
                    code: 14 /* KEY_SESSION_UPDATE_FAILED */,
                    message: t(i18nCore.ERROR_DRM_KEY_SESSION_UPDATE_FAILED),
                });
                return;
            }
            var updatePromise = keySession.update(data);
            // 兼容一下webkit fps，只有标准EME实现update才会返回promise
            updatePromise === null || updatePromise === void 0 ? void 0 : updatePromise.catch(function (error) {
                _this.emit(ERR, {
                    code: 14 /* KEY_SESSION_UPDATE_FAILED */,
                    message: t(i18nCore.ERROR_DRM_KEY_SESSION_UPDATE_FAILED),
                });
                return;
            });
        });
    };
    /**
     * 创建widevine license的xhr请求
     * ! widevine的请求数据为event.message
     */
    DRM.prototype.createWidevineLicenseRequest = function (event, callback) {
        var _this = this;
        var message = event.message;
        var opts = {
            method: 'POST',
            responseType: 'arraybuffer',
            body: message,
            url: this.config.licenseUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        if (this.config.licenseRequestSetup) {
            opts = this.config.licenseRequestSetup(opts);
        }
        netTool.xhr(opts)
            .then(function (response) {
            callback(response);
        })
            .catch(function (error) {
            var _a = error || {}, code = _a.code, message = _a.message;
            _this.emit(ERR, {
                code: 11 /* LICENSE_REQUEST_FAILED */,
                detail: code,
                message: t(i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED, "[code: ".concat(code, "] ").concat(message)),
            });
        });
    };
    /**
     * 创建playready的license请求
     */
    DRM.prototype.createPlayReadyLicenseRequest = function (event, callback) {
        var _this = this;
        var message = event.message;
        var keyMessageXML = builtMessageXML(message);
        var opts = {
            method: 'POST',
            responseType: 'arraybuffer',
            body: getChallenge(keyMessageXML),
            url: this.config.licenseUrl,
            headers: builtHeadersFromXML(keyMessageXML),
        };
        if (this.config.licenseRequestSetup) {
            opts = this.config.licenseRequestSetup(opts);
        }
        netTool.xhr(opts)
            .then(function (response) {
            callback(response);
        })
            .catch(function (error) {
            _this.logger.warn('failed to get license', error);
            _this.emit(ERR, {
                code: 11 /* LICENSE_REQUEST_FAILED */,
                message: t(i18nCore.ERROR_DRM_LICENSE_REQUEST_FAILED, error === null || error === void 0 ? void 0 : error.message),
            });
        });
    };
    /**
     * 创建fps license的xhr请求
     * ! fps的基础请求数据为spc=data, 其中data是base64编码的event.message
     */
    DRM.prototype.createFPSLicenseRequest = function (event, callback) {
        var _this = this;
        var message = event.message;
        var spcMessage = encodeURIComponent(stringTool.arrayBufferToBase64(message));
        var opts = {
            method: 'POST',
            responseType: 'arraybuffer',
            body: "spc=".concat(spcMessage, "&assetId=").concat(this.mediaKeyDescriptor.assetID),
            url: this.config.licenseUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        if (this.config.licenseRequestSetup) {
            opts = this.config.licenseRequestSetup(opts);
        }
        netTool.xhr(opts)
            .then(function (response) {
            callback(response);
        })
            .catch(function (error) {
            _this.logger.warn('license request error', error);
            _this.emit(ERR, {
                code: 11 /* LICENSE_REQUEST_FAILED */,
                message: t(i18nCore.LICENSE_REQUEST_FAILED),
            });
        });
    };
    /**
     * ====================================================================================
     * Apple Fairplay Webkit标准的加密播放流程
     * 1. 创建webkit mediaKey
     * 2. 绑定mediakey到video，这里需要先绑定后创建session
     * 3. 监听webkitneededkey，拼装initData并创建session
     * 4. 监听session的message事件，创建license请求
     * 5. 更新session的解密信息
     */
    /**
     * 创建webkit mediaKey
     */
    DRM.prototype.requestFPSMediaKeys = function () {
        var mediaKey = new window.WebKitMediaKeys(KeySystems.FairPlayWebKit);
        // ! fps1.0 need to set key before create session
        this.media.webkitSetMediaKeys(mediaKey);
        // 这里如果设置失败了，在createSession的时候会因为没有mediakey而报错
        this.mediaKeyDescriptor = {
            mediaKeySession: null,
            initData: null,
            hasInitialized: false,
            mediaKeySystemAccess: null,
            mediaKeys: this.media.webkitKeys,
        };
        return Promise.resolve(mediaKey);
    };
    /**
     * 创建webkit mediakey的session
     */
    DRM.prototype.createFPSWebkitSession = function (mediaKeys, initData) {
        // 这里取到的mediaKey是绑定在video标签上的，如果绑定失败了会在这里抛出
        if (!mediaKeys) {
            this.emit(ERR, {
                code: 8 /* FPS_SET_KEY_FAILED */,
                message: t(i18nCore.ERROR_DRM_FPS_SET_KEY_FAILED),
            });
            return;
        }
        // 创建session失败时返回为null
        // todo 其实如果sessionId为空也应该判别为失败
        var session = mediaKeys.createSession('video/mp4', initData);
        if (!session) {
            this.emit(ERR, {
                code: 2 /* KEY_SESSION_CREATION_FAILED */,
                message: t(i18nCore.ERROR_DRM_KEY_SESSION_CREATION_FAILED),
            });
            return;
        }
        return session;
    };
    /**
     * 清理webkit mediakey session
     */
    DRM.prototype.cleanupFPSSession = function (mediaKeySession) {
        if (!mediaKeySession)
            return Promise.resolve();
        this.media.webkitSetMediaKeys(null);
        mediaKeySession.onwebkitkeyadded = null;
        mediaKeySession.onwebkitkeyerror = null;
        mediaKeySession.onwebkitkeymessage = null;
        return Promise.resolve();
    };
    /**
     * 服务器证书缓存，目前只有fairplay会用到
     */
    DRM.serverCertificate = {};
    return DRM;
}(EvtEmitter));
export default DRM;
;
